<template>
  <v-app>
    <v-main v-if="online">
      <router-view />
    </v-main>
    <div class="no-internet" v-else>
      <img :src="logo" class="abs-nowifi" alt="" />
      <img :src="nodataImg" alt="" />
      <div>لا يتوفر اتصال بالانترنت</div>
      <div class="flex-group-me">
        <button class="main-btn up lg" @click="retry">اعد المحاولة</button>
      </div>
    </div>
  </v-app>
  <Toast />
</template>

<script>
import "@/assets/css/style.css";
import "@/assets/css/style-ltr.scss";
import Toast from "primevue/toast";
import { useNetwork } from "@vueuse/core";

const { isOnline } = useNetwork();

export default {
  components: { Toast },
  data() {
    return {
      online: false,
      nodataImg: require("../src/assets/imgs/no-wifi.svg"),
      logo: require("../src/assets/imgs/logo.png"),
    };
  },

  mounted() {
    if (localStorage.getItem("locale") == "en") {
      document.querySelector("body").classList.add("ltr");
    } else {
      document.querySelector("body").classList.remove("ltr");
    }
    this.online = isOnline.value;
  },
  methods: {
    retry() {
      this.online = isOnline.value;
    },
  },

  watch: {
    $route() {
      this.online = isOnline.value;
    },
  },
};
</script>
<style>
#app {
  font-family: "myfont", sans-serif;
}
a {
  text-decoration: none !important;
}
ul {
  margin-bottom: 0 !important;
}
</style>
